
import { useForm } from "react-hook-form";
import { useLabelsContext } from "../context/LabelsContext";
import { isValidIsraeliID } from "../utils/helpers";
import { LoginFields } from "../models/login-fields";
import { useCallback, useEffect } from "react";
import { useAuthContext } from "../context/AuthContext";
import { LOGIN_METHODS } from "../models/login-methods";

export const useLoginForm = () => {
    const { labels } = useLabelsContext();
    const { loginMethod, interestedUser } = useAuthContext();
    const {
        register,
        handleSubmit,
        trigger,
        getValues,
        setError,
        setValue,
        clearErrors,
        formState: { errors },
    } = useForm<LoginFields>({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const loginForm = {
        [loginMethod]: {
            required: labels?.["RequiredField"],
            validate: (value: string | number | undefined) => {
                if (loginMethod === LOGIN_METHODS.PASSPORT) {
                    return (isValidIsraeliID(String(value)) || labels?.["InvalidPassport"] || "Invalid passport");
                }
                if (loginMethod === LOGIN_METHODS.EMAIL) {
                    const emailRegex = new RegExp(labels?.["MailRegex"] || "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$", "i");

                    return (emailRegex.test(String(value ?? "")) || labels?.["MailNotValid"] || "Invalid email");
                }
                return true;
            },
        }
    };

    const getErrorMessage = useCallback((field: keyof LoginFields): { key: string, message: string } | null => {
        if (!errors[field]?.message) return null;
        const errorMessage = String(errors[field]?.message ?? "");
        const labelKey = Object.keys(labels || {}).find(key => labels?.[key] === errorMessage);

        return {
            key: labelKey ?? "",
            message: errorMessage
        };
    }, [errors, labels]);

    useEffect(() => {
        if (interestedUser && !interestedUser.verified && loginMethod === LOGIN_METHODS.GUESTID) {
            setValue(loginMethod, interestedUser?.GuestId?.toString());
            clearErrors();
        }
    }, [interestedUser, loginMethod]);

    return {
        register,
        handleSubmit,
        trigger,
        getValues,
        setError,
        errors,
        loginForm,
        getErrorMessage,
        setValue
    }
}
